<template>
  <b-row class="w-100">
    <!-- <b-col md="4">
      <SearchBar class="w-75 pt-2" @getHolidays="getHolidaysByType" />
    </b-col> -->
    <b-col md="4">
      <StatusFilter
        v-if="statusFilter"
        class="w-75"
        @getHolidays="getHolidaysByType"
      />
    </b-col>
<!--     <b-col>
      <TypeFilter v-if="shouldToggle" class="w-50" @getHolidays="getHolidaysByType" />
    </b-col> -->
    <b-col>
      <b-button @click="openModal(null, 'create-holiday')">Nuevo</b-button>
    </b-col>
  </b-row>
</template>

<script>
import DateFilter from './dateFilter.vue'
import SearchBar from './searchBar.vue'
import StatusFilter from './statusFilter.vue'
import UserFilter from './userFilter.vue'
import TypeFilter from './typeFilter.vue'
import { BRow, BCol, BButton } from 'bootstrap-vue'
import { mapState, mapMutations } from 'vuex'

export default {
  components: {
    DateFilter,
    SearchBar,
    StatusFilter,
    BRow,
    BCol,
    TypeFilter,
    UserFilter,
    BButton
  },
  props: {
    shouldToggle: Boolean,
    statusFilter: {
      default: true,
    },
    userFilter: {
      default: false,
    },
  },
  methods: {
    openModal(holiday, type) {
      this.toggleModal({ value: true, type })
    },
    getHolidaysByType() {
      this.$emit('getHolidays')
    },
    ...mapMutations('locations', ['toggleModal']),
  },
  computed: {
    ...mapState('tableFilters', ['selectedTypeFilter']),
  },
}
</script>
